module.exports = __webpack_public_path__ + "img/Flag_of_the_United_Kingdom.da08e077.svg";